export { default as ListBulletAltSolid } from './ListBulletAltSolid';
